var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-second-border" }, [
      _c("div", { staticClass: "payment-second-content-parent" }, [
        _c("div", { staticClass: "payment-second-title" }, [
          _vm._v("About net 60 terms")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-second-child-title" }, [
          _vm._v("Order new inventory today,pay 60 days later")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-second-content" }, [
          _vm._v(
            "Purchases made with net 60 terms won’t be charged until 60 days later after you order—giving you time to sell products before ever paying for them."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2636a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2636a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/payment-second.vue
// module id = null
// module chunks = 